/**
 * Created by jiayanfeng on 2017/9/20.
 * Modified by jiayanfeng on 2018/3/27.
 * Action常量
 */
export const Space_Apps_Table_Data_Fetch = "Space_Apps_Management/Table_Data_Fetch";
export const Text_Search_Column_Change = "Space_Apps_Management/Text_Search_Change";
export const Select_Search_Column_Change = "Space_Apps_Management/Select_Search_Change";
export const Select_Category_Column_Change = "Space_Apps_Management/Select_Category_Change";
